export default __webpack_public_path__ + "static/media/cold-chain-marker.6e4c0200.svg";